import { Injectable } from '@angular/core';
import { Fournisseur } from '../model/fournisseur';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class FournisseurService{
  
    constructor(private _restClientService : RestClientService) { }


    getFournisseursByRequestId(requestId){
      return this._restClientService.load<Fournisseur[]>('fournisseur/fournisseurs-by-requestId?requestId='+requestId);
    }

    getFournisseurById(fournisseurId){
      return this._restClientService.load<Fournisseur>('fournisseur/fournisseur-by-id/'+fournisseurId);
    }
    
    addFournisseur(fournisseur) {
      return  this._restClientService.save<Fournisseur>('fournisseur/add-fournisseur', fournisseur);
    }

    updateFournisseur(fournisseur) {
      return  this._restClientService.put<Fournisseur>(`fournisseur/update-fournisseur`, fournisseur);
    }

    deleteFournisseurById(fournisseurId) 
    {
        return this._restClientService.delete<any>('fournisseur/delete-fournisseur/'+fournisseurId);
    }

    addListFournisseur(fournisseurList) {
      return  this._restClientService.save<Fournisseur>('fournisseur/add-fournisseur-list', fournisseurList);
    }

  
  

}      

    